module.exports = __webpack_public_path__ + "img/success.a9eca712.png";